const strings = {
  RegistracijaZaPodjetja: 'Registracija za podjetja',
  PoOpravljeniRegistraciji:
    'Po opravljeni registraciji vam poslali še nekaj koristnih informacij',
  Cvetličarne: 'Cvetličarne',
  PogrebnaPodjetja: 'Pogrebna podjetja',
  Podjetje: 'Podjetje',
  ImeCvetličarne: 'Ime cvetličarne',
  Regiji: 'Regiji',
  Mesto: 'Mesto',
  Epošta: 'E-pošta',
  IzberiGeslo: 'Izberi geslo',
  PonoviGeslo: 'Ponovi geslo',
  Min8Znakov: '(Min 8 znakov. Vsaj ena mala in velika črka in številka)',
  Registriraj: 'Registriraj',
  RegistracijaUporabnikov: 'Registracija uporabnikov',
  PišiteNam: 'Pišite nam',
  ImeEnote: 'Ime enote',
  Pišitenam: 'Pišite nam!',
  ImateVprašanjePredlogeKomentarjePišiteNam:
    'Imate vprašanje, predloge, komentarje?  Pišite nam!',
  Pošlji: 'Pošlji',
  Ime: 'Ime',
  Zadeva: 'Zadeva',
  Sporočilo: 'Sporočilo',
  ObičajnoOdgovorimoVNekajUrah: 'Običajno odgovorimo še isti dan. ',
  ImateVprašanjePredlogeKomentarje: 'Imate vprašanje, predloge, komentarje?',
  Objavi: 'Objavi',
  POŠLJINOVOGESLO: 'POŠLJI NOVO GESLO',
  DodajReligiozniSimbol: 'Dodaj religiozni simbol',
  PrikazanBoVSeznamu: 'Prikazan bo v seznamu osmrtnic in na spominski strani.',
  PozabljenoGeslo: 'Pozabljeno geslo',
  VnesiNaslov:
    'Vnesi naslov spletne pošte, ki si ga uporabil pri registraciji.',
  ČeImašTežave:
    'Če imaš težave pri obnovitvi računa, lahko pošlješ sporočilo na Pomoč uporabnikom. Običajno odgovorimo še isti dan.',
  SvečkaJeZagorela: 'Svečka je zagorela',
  ZadnjaPrižganaSvečka: 'Zadnja prižgana svečka pred tvojo:',
};

export default strings;
